var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14272",
    "data-name": "Group 14272",
    transform: "translate(-8 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13089",
    "data-name": "Path 13089",
    d: "M15.473,12.345A7.778,7.778,0,0,0,8.5,7.5a7.778,7.778,0,0,0-6.972,4.845.443.443,0,0,0,0,.309A7.778,7.778,0,0,0,8.5,17.5a7.778,7.778,0,0,0,6.972-4.845.443.443,0,0,0,0-.309ZM8.5,16.591A6.928,6.928,0,0,1,2.466,12.5,6.928,6.928,0,0,1,8.5,8.409,6.928,6.928,0,0,1,14.535,12.5,6.928,6.928,0,0,1,8.5,16.591Z",
    transform: "translate(6.5 -0.5)",
    fill: "#6249ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13090",
    "data-name": "Path 13090",
    d: "M17.8,15a2.728,2.728,0,1,0,2.8,2.727A2.764,2.764,0,0,0,17.8,15Zm0,4.545a1.819,1.819,0,1,1,1.867-1.818A1.843,1.843,0,0,1,17.8,19.545Z",
    transform: "translate(-2.8 -5.727)",
    fill: "#6249ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPurple);
export default __webpack_public_path__ + "static/media/viewPurple.b044525306ed8fe3c376d4fdd46e872b.svg";
export { ForwardRef as ReactComponent };